import { FlagsComponentRouter, FlagsSingleton } from 'flags'
import {
  isMiddleSchoolUrl,
  isMiddleSchoolDashboard,
  isK5Url,
  isK5Dashboard,
} from 'utils/productHelpers'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: [
    'feature_LEARN-20108-ms-site-selection',
    'feature_LEARN-20164-k5-site-selection',
  ],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) => {
    // Check for middle school context with feature flag enabled
    const isMiddleSchool =
      (isMiddleSchoolUrl() || isMiddleSchoolDashboard()) &&
      subscribedFlags['feature_LEARN-20108-ms-site-selection']

    // Check for K5 context with feature flag enabled
    const isK5 =
      (isK5Url() || isK5Dashboard()) &&
      subscribedFlags['feature_LEARN-20164-k5-site-selection']

    return isMiddleSchool || isK5
  },
})

export default FlagToggler
